import adminHttp from "@/api/adminHttp";


/**
 * status+, ticket, categories+, actions+, user groups+-, types+ => admin (чисто админское)
 *
 * */
export default {
    // Ticket list
    getListTickets: (params = {
        page: 1,
        per_page: 10
    }) => adminHttp.get('/api/tickets', {
        params,
    }),
    createTicket: (data) => adminHttp.post('/api/tickets', data),
    getTicket: (ticketId) => adminHttp.get(`/api/tickets/${ticketId}`),
    updateTicket: (ticketId, data) => adminHttp.put(`/api/tickets/${ticketId}`, data),
    deleteTicket: (ticketId) => adminHttp.delete(`/api/tickets/${ticketId}`),
    updateActionFromTicket: (ticketId, actionId, data) => adminHttp.put(`/api/tickets/${ticketId}/actions/${actionId}`, data),
    // Ticket action statuses
    getListActionStatuses: () => adminHttp.get('/api/ticket-action-statuses'),
    createActionStatus: (data) => adminHttp.post('/api/ticket-action-statuses', data),
    getActionStatus: (statusId) => adminHttp.get(`/api/ticket-action-statuses/${statusId}`),
    updateActionStatus: (statusId, data) => adminHttp.put(`/api/ticket-action-statuses/${statusId}`, data),
    deleteActionStatus: (statusId) => adminHttp.delete(`/api/ticket-action-statuses/${statusId}`),
    // Ticket categories
    getListTicketCategories: (params = {
        type_id: 1,
        enabled: false
    }) => adminHttp.get('/api/ticket-categories', {
        params
    }),
    createTicketCategory: (data) => adminHttp.post('/api/ticket-categories', data),
    getTicketCategory: (categoryId) => adminHttp.get(`/api/ticket-categories/${categoryId}`),
    updateTicketCategory: (categoryId, data) => adminHttp.put(`/api/ticket-categories/${categoryId}`, data),
    deleteTicketCategory: (categoryId) => adminHttp.delete(`/api/ticket-categories/${categoryId}`),
    // Ticket types
    getListTicketTypes: (params = {
        page: 1,
        per_page: 15
    }) => adminHttp.get('/api/ticket-types', {
        params
    }),
    createTicketType: (data) => adminHttp.post('/api/ticket-types', data),
    getTicketType: (typeId) => adminHttp.get(`/api/ticket-types/${typeId}`),
    updateTicketType: (typeId, data) => adminHttp.put(`/api/ticket-types/${typeId}`, data),
    deleteTicketType: (typeId) => adminHttp.delete(`/api/ticket-types/${typeId}`),
    // Ticket actions (подождать Данияра)
    getListTicketActions: (params = {
        page: 1,
        per_page: 15
    }) => adminHttp.get('/api/ticket-actions', {
        params
    }),
    createTicketAction: (data) => adminHttp.post('/api/ticket-actions', data),
    getTicketAction: (actionId) => adminHttp.get(`/api/ticket-actions/${actionId}`),
    updateTicketAction: (actionId, data) => adminHttp.put(`/api/ticket-actions/${actionId}`, data),
    deleteTicketAction: (actionId) => adminHttp.delete(`/api/ticket-actions/${actionId}`),
    // Ticket groups
    getListUserGroups: () => adminHttp.get('/api/ticket-user-groups'),
    createUserGroup: (data) => adminHttp.post('/api/ticket-user-groups', data),
    getUserGroup: (groupId) => adminHttp.get(`/api/ticket-user-groups/${groupId}`),
    updateUserGroup: (groupId, data) => adminHttp.put(`/api/ticket-user-groups/${groupId}`, data),
    deleteUserGroup: (groupId) => adminHttp.delete(`/api/ticket-user-groups/${groupId}`),
    getListGroupUsers: (groupId) => adminHttp.get(`/api/ticket-user-groups/${groupId}/users`),
    addUserToGroup: (groupId, data) => adminHttp.post(`/api/ticket-user-groups/${groupId}/users`, data),
    removeUserFromGroup: (groupId, userId) => adminHttp.delete(`/api/ticket-user-groups/${groupId}/users/${userId}`),
    // ticket messages
    getListOfMessages: (ticketId, params) => adminHttp.get(`/api/tickets/${ticketId}/messages`, {
        params
    }),
    sendMessage: (ticketId, data) => {
        const config = data instanceof FormData ? {headers: {'Content-Type': 'multipart/form-data'}} : {}
        return adminHttp.post(`/api/tickets/${ticketId}/messages`, data, config)
    },
    markMessageAsRead: (ticketId) => adminHttp.post(`/api/tickets/${ticketId}/messages/read`),
    getTicketHistory: (ticketId) => adminHttp.get(`/api/tickets/${ticketId}/histories`),
}